module.exports = __webpack_public_path__ + "static/img/book.01eb3af8.png";